"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.THS_API = {
  URL: 'https://apis.solarialabs.com/shine/v1/total-home-scores',
  REPORTS: 'reports',
  ANALYTICS: 'track'
};